import { render, staticRenderFns } from "./rankTable.vue?vue&type=template&id=259c34fa&scoped=true"
import script from "./rankTable.vue?vue&type=script&lang=ts"
export * from "./rankTable.vue?vue&type=script&lang=ts"
import style0 from "./rankTable.vue?vue&type=style&index=0&id=259c34fa&prod&lang=scss"
import style1 from "./rankTable.vue?vue&type=style&index=1&id=259c34fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259c34fa",
  null
  
)

export default component.exports